"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BATServices = exports.FOTACharacteristics = exports.LogCharacteristics = exports.DeviceManagementCharacteristics = exports.AVCharacteristics = exports.VapingCharacteristics = void 0;
/* eslint-disable no-underscore-dangle */
var VapingCharacteristics;
(function (VapingCharacteristics) {
    VapingCharacteristics["DEVICE_INFORMATION"] = "DEVICE_INFORMATION";
    VapingCharacteristics["TIME"] = "TIME";
    VapingCharacteristics["BATTERY"] = "BATTERY";
    VapingCharacteristics["LOCK"] = "LOCK";
    VapingCharacteristics["PUFF_RECORDS"] = "PUFF_RECORDS";
    VapingCharacteristics["FIND_MY_VAPE"] = "FIND_MY_VAPE";
    VapingCharacteristics["LED"] = "LED";
    VapingCharacteristics["CLOUD_CONTROL"] = "CLOUD_CONTROL";
    VapingCharacteristics["FACTORY_RESET"] = "FACTORY_RESET";
    VapingCharacteristics["HAPTIC"] = "HAPTIC";
    VapingCharacteristics["BUZZER"] = "BUZZER";
    VapingCharacteristics["POD_CONNECTION_DETECTION"] = "POD_CONNECTION_DETECTION";
    VapingCharacteristics["BLE_TIMEOUT"] = "BLE_TIMEOUT";
    VapingCharacteristics["POD_INFORMATION"] = "POD_INFORMATION";
    VapingCharacteristics["POWER_SAVER_MODE"] = "POWER_SAVER_MODE";
})(VapingCharacteristics = exports.VapingCharacteristics || (exports.VapingCharacteristics = {}));
var AVCharacteristics;
(function (AVCharacteristics) {
    AVCharacteristics["CHALLENGE_GENERATION"] = "CHALLENGE_GENERATION";
    AVCharacteristics["SIGNATURE_VERIFICATION"] = "SIGNATURE_VERIFICATION";
})(AVCharacteristics = exports.AVCharacteristics || (exports.AVCharacteristics = {}));
var DeviceManagementCharacteristics;
(function (DeviceManagementCharacteristics) {
    DeviceManagementCharacteristics["VERSION"] = "VERSION";
    DeviceManagementCharacteristics["CONTROL"] = "CONTROL";
    DeviceManagementCharacteristics["PAYLOAD"] = "PAYLOAD";
    DeviceManagementCharacteristics["CHALLENGE"] = "CHALLENGE";
})(DeviceManagementCharacteristics = exports.DeviceManagementCharacteristics || (exports.DeviceManagementCharacteristics = {}));
var LogCharacteristics;
(function (LogCharacteristics) {
    LogCharacteristics["LAST_ERROR"] = "LAST_ERROR";
    LogCharacteristics["LOG_RECORD"] = "LOG_RECORD";
})(LogCharacteristics = exports.LogCharacteristics || (exports.LogCharacteristics = {}));
var FOTACharacteristics;
(function (FOTACharacteristics) {
    FOTACharacteristics["CONTROL_POINT"] = "CONTROL_POINT";
    FOTACharacteristics["DFU_PACKET"] = "DFU_PACKET";
    FOTACharacteristics["BUTTON_LESS"] = "BUTTON_LESS";
})(FOTACharacteristics = exports.FOTACharacteristics || (exports.FOTACharacteristics = {}));
var BATServices;
(function (BATServices) {
    BATServices["VAPING"] = "VAPING";
    BATServices["LOG"] = "LOG";
    BATServices["DFU"] = "DFU";
    BATServices["DEVICE_MANAGEMENT"] = "DEVICE_MANAGEMENT";
    BATServices["AGE_VERIFICATION"] = "AGE_VERIFICATION";
})(BATServices = exports.BATServices || (exports.BATServices = {}));
var DeviceCharacteristic = /** @class */ (function () {
    function DeviceCharacteristic() {
    }
    return DeviceCharacteristic;
}());
exports.default = DeviceCharacteristic;
